/* Lazy product recommendations; links keep each product's personalization flow intact. */
(() => {
  if (customElements.get('product-discovery')) return;
  class ProductDiscovery extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-discovery-grid] > li')) { this.hidden = false; return; }
      if (!this.dataset.url || this.controller) return;
      this.controller = new AbortController();
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      }, {rootMargin: '400px 0px'});
      // The section shell remains measurable until loading completes.
      this.observer.observe(this);
    }
    async load() {
      try {
        const response = await fetch(this.dataset.url, {signal: this.controller.signal});
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = html.getElementById(this.dataset.gridId);
        if (!grid?.querySelector('li')) { this.hidden = true; return; }
        this.querySelector('[data-discovery-grid]').replaceChildren(...grid.children);
        this.querySelector('[data-discovery-content]').hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError') this.hidden = true;
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.controller = null; }
  }
  customElements.define('product-discovery', ProductDiscovery);
})();
